import { Input } from '../ui/input';
import { useLanguage } from '@/contexts/AppContext';
import { ProfileData } from '../../hooks/useProfileState';
import { profileTranslations } from './profileTranslations';

interface ProfileFormProps {
  isEditing: boolean;
  profileData: ProfileData;
  setProfileData: React.Dispatch<React.SetStateAction<ProfileData>>;
}

export function ProfileForm({
  isEditing,
  profileData,
  setProfileData,
}: ProfileFormProps) {
  const { locale } = useLanguage();
  const t = profileTranslations[locale];

  return (
    <div className="space-y-[min(5vw,1.5rem)]">
      {/* Full Name */}
      <div className="space-y-[min(2.5vw,0.625rem)]">
        <label className="text-[min(3.5vw,0.875rem)] font-medium text-muted-foreground block">
          {t.fullName}
        </label>
        {isEditing ? (
          <Input
            value={profileData.name}
            onChange={(e) => setProfileData({ ...profileData, name: e.target.value })}
            autoComplete="name"
            className="h-[min(12vw,3rem)] bg-background border-2 border-border rounded-[5px] px-[min(4vw,1rem)] focus:border-primary focus:ring-2 focus:ring-primary/20"
          />
        ) : (
          <div className="h-[min(12vw,3rem)] flex items-center px-[min(4vw,1rem)] bg-muted rounded-[5px]">
            <p className="text-[min(4vw,1rem)] text-foreground">
              {profileData.name}
            </p>
          </div>
        )}
      </div>

      {/* Phone */}
      <div className="space-y-[min(2.5vw,0.625rem)]">
        <label className="text-[min(3.5vw,0.875rem)] font-medium text-muted-foreground block">
          {t.phone}
        </label>
        {isEditing ? (
          <Input
            value={profileData.phone}
            readOnly
            className="h-[min(12vw,3rem)] bg-muted border-2 border-border rounded-[5px] px-[min(4vw,1rem)] cursor-not-allowed opacity-60"
          />
        ) : (
          <div className="h-[min(12vw,3rem)] flex items-center px-[min(4vw,1rem)] bg-muted rounded-[5px]">
            <p className="text-[min(4vw,1rem)] text-foreground">
              {profileData.phone}
            </p>
          </div>
        )}
      </div>

      {/*
        Email
        편집 가능한 input으로 노출하면 `handleSave`가 `email`을 payload에 싣지 않기 때문에
        저장 성공 토스트와 상반된 stale 상태가 된다(silent UX failure).
        변경 지원 전까지 phone과 동일하게 read-only 처리.
      */}
      <div className="space-y-[min(2.5vw,0.625rem)]">
        <label className="text-[min(3.5vw,0.875rem)] font-medium text-muted-foreground block">
          {t.email}
        </label>
        {isEditing ? (
          <Input
            value={profileData.email}
            readOnly
            type="email"
            autoComplete="off"
            className="h-[min(12vw,3rem)] bg-muted border-2 border-border rounded-[5px] px-[min(4vw,1rem)] cursor-not-allowed opacity-60"
          />
        ) : (
          <div className="min-h-[min(12vw,3rem)] flex items-center px-[min(4vw,1rem)] bg-muted rounded-[5px] py-[min(3vw,0.75rem)]">
            <p className="text-[min(4vw,1rem)] text-foreground break-all">
              {profileData.email}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
